export default "__VITE_ASSET__BwgrESkh__"